import { StatusState } from "store/types";

export enum TEventTab {
  PAST = "past",
  UPCOMING = "upcoming",
  CANCELLED = "canceled",
  TENTATIVE = "tentative"
}

export interface IEventListData {
  id: number;
  activity_title: string;
  start_date_time: string;
  condition_type: string;
  visuals: Array<{
    image_url: string;
  }>;
  places: Array<{
    place_city: string;
    place_state: string;
    place_postcode: string;
  }>;
}

export interface SearchDocumentsPayload {
  orderBy?: string;
  arrangeOrder?: "asc" | "desc";
  searchText?: string;
  typeEvents: TEventTab;
  dataPage?: number;
  limit?: number;
}

export interface FetchEventListParams {
  page: number;
  limit: number;
  typeEvents: TEventTab ;
  searchText: string;
  publicUserId?: number;
}

export interface FetchEventListResponse {
  data: IEventListData[];
  pagination: {
    totalPages: number;
    currentPage: number;
  };
}

export interface EventListState {
  data: IEventListData[];
  pagination: {
    total_pages: number;
    current_page: number;
  };
  status:StatusState;
  error: string | null;
}
